import getFormattedScore from "src/utils/prediction/getFormattedScore";

const ScoreCell = ({ value }) => getFormattedScore(value);

export default ScoreCell;
